import { useMutation } from "react-query";
import { putDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { appInsights } from "../../../config/appInsights";
import { message } from "antd";
import { errorHandler } from "../../../helpers/errorHandler";

export type TUpdateAdminUserPayload = {
  id: number;
  firstName: string;
  lastName: string;
  phone: string;
  isActive: boolean;
};

const updateAdminUser = async (
  payload: TUpdateAdminUserPayload,
): Promise<void> => {
  await putDataWithDotNet(ajaxEndpoints.MANAGE_ADMIN_USER, payload);
};

export function useUpdateAdminUser() {
  const [mutate, result] = useMutation(
    (payload: TUpdateAdminUserPayload) => updateAdminUser(payload),
    {
      onSuccess: () => {
        message.success("User has been updated successfully.");
      },
      onError: (error: any) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useUpdateAdminUser.ts" },
        });
        message.error(errorHandler(error));
      },
    },
  );

  return { mutate, result };
}
